import { render, staticRenderFns } from "./AnchorArea.vue?vue&type=template&id=ce600a20"
import script from "./AnchorArea.vue?vue&type=script&lang=js"
export * from "./AnchorArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports